import React from 'react';
import { ImageWrapper, SvgButton } from './styled';
import useViewSettings from '../../../preload/pages/CategoryPage/Providers/ViewSettingsProvider';
import {
  GridFilterActiveLarge,
  GridFilterActiveSmall,
  GridFilterHoverLarge,
  GridFilterHoverSmall,
  GridFilterPassiveLarge,
  GridFilterPassiveSmall,
} from '../../../styled/Icon';

const GridFilter = () => {
  const { productView, enableLargeGrid, enableSmallGrid } = useViewSettings();

  return (
    <ImageWrapper>
      <SvgButton
        className={productView === 'grid-large' ? 'active' : undefined}
        onClick={enableLargeGrid}>
        <GridFilterActiveLarge className="xlarge active" />
        <GridFilterHoverLarge className="xlarge hover" />
        <GridFilterPassiveLarge className="xlarge passive" />
      </SvgButton>
      <SvgButton
        className={productView === 'grid-small' ? 'active' : undefined}
        onClick={enableSmallGrid}>
        <GridFilterActiveSmall className="xlarge active" />
        <GridFilterHoverSmall className="xlarge hover" />
        <GridFilterPassiveSmall className="xlarge passive" />
      </SvgButton>
    </ImageWrapper>
  );
};
export default GridFilter;
